import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { animate, group, state, style, transition, trigger } from '@angular/animations';

import 'rxjs/add/operator/startWith';

@Component({
    selector: 'ssf-accordion',
    template: require('./accordion.component.html'),
    styles: [require('./accordion.component.scss')],
    animations: [
        trigger('slideInOut', [
            state('in', style({
                'height': '*', 'opacity': '1', 'visibility': 'visible'
            })),
            state('out', style({
                'height': '0px', 'opacity': '0', 'visibility': 'hidden'
            })),
            transition('in => out', [group([
                    animate('400ms ease-in-out', style({'opacity': '0'})),
                    animate('400ms 200ms ease-in-out', style({height: 0})),
                    animate('500ms ease-in-out', style({'visibility': 'hidden'}))
                ]
            )]),
            transition('out => in', [group([
                    animate('1ms ease-in-out', style({'visibility': 'visible'})),
                    animate('400ms ease-in-out', style({'height': '*'})),
                    animate('400ms 200ms ease-in-out', style({'opacity': '1'}))
                ]
            )])
        ])
    ]
})
export class AccordionComponent implements OnChanges {
    @Input() shown;
    @Output() toggle = new EventEmitter<boolean>();
    public animationState = 'out';

    toggleDetails() {
        this.toggle.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.initAnimationState(changes.shown.currentValue);
    }

    initAnimationState(shown: boolean) {
        this.animationState = shown ? 'in' : 'out';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/accordion/accordion.component.ts